import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useConsent } from '../../context/ConsentContext';
import ConsentModal from './ConsentModal';
import '../../styles/consent.css';

const CookieBanner: React.FC = () => {
  const { t } = useTranslation('consent');
  const { showBanner, acceptAll, rejectAll } = useConsent();
  const [showModal, setShowModal] = useState(false);

  if (!showBanner) return null;

  return (
    <>
      <div className="cookie-banner" role="region" aria-label={t('banner.aria_label')}>
        <p className="cookie-banner__text">
          {t('banner.text')}{' '}
          <Link to="/privacy">{t('banner.learn_more')}</Link>
        </p>
        <div className="cookie-banner__actions">
          <button className="cookie-banner__btn cookie-banner__btn--reject" onClick={rejectAll}>
            {t('banner.reject_all')}
          </button>
          <button className="cookie-banner__btn cookie-banner__btn--customize" onClick={() => setShowModal(true)}>
            {t('banner.customize')}
          </button>
          <button className="cookie-banner__btn cookie-banner__btn--accept" onClick={acceptAll}>
            {t('banner.accept_all')}
          </button>
        </div>
      </div>
      {showModal && <ConsentModal onClose={() => setShowModal(false)} />}
    </>
  );
};

export default CookieBanner;
